export default {
    cancel: 'Cancelar',
    fingerModalClose: 'Cerrar ventana modal',
    modalTitle: 'Información importante',
    modalContent:
    'Cuando haga clic en "Continuar" se abrirá una pestaña o ventana nueva en otro sitio web y esta pestaña permanecerá abierta. No se olvide de volver a la herramienta Legal Tune Up para dar seguimiento a acciones adicionales que tal vez pueda tomar relativo a sus registros legales.',
    proceed: 'Continuar',
};
